/* eslint-disable */
import {stringifyVideoTimeWithColons} from "../common/video/util/videoTimeStrings";
import {UserRole} from "../models/user";
import {VideoCaption} from "../models/video";
import {isNullorUndefined} from "./ObjectUtils";

// User権限判定
export function isUser(roles: UserRole[] | undefined) {
    return roles?.length === 0;
}

// Admin権限判定
export function isAdmin(roles: UserRole[] | undefined) {
    return !!roles?.some((role) => role.role === "ADMIN");
}

// Presenter権限判定
export function isPresenter(roles: UserRole[] | undefined) {
    return !!roles?.some((role) => role.role === "PRESENTER");
}

// Guest権限判定
export function isGuest(roles: UserRole[] | undefined) {
    return !!roles?.some((role) => role.role === "GUEST");
}

// API実行エラー判定
export function isAxiosError(error: any) {
    return isNullorUndefined(error) ? false : error.isAxiosError;
}

// 指定範囲内の乱数を生成する
export function getRandomInt(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min);
}

// パラメータをメッセージに設定する
export function setMessageArgs(str: string, ...args: string[]) {
    let message = str;
    for (let i = 0; i < args.length; i++) {
        message = message.replace(`{${i}}`, args[i]);
   }

    return message;
}

// ビデオ処理ステータス判定
export function getVideoStatus(status: string){
    switch (status.toUpperCase()){
        case "CREATED":
            return "Video処理中";
        case "UPLOADED":
        case "EXTRACTING_AUDIO":
            return "オーディオ抽出中";
        case "CREATING_CAPTIONS":
            return "字幕作成中";
        case "CREATING_THUMBNAILS":
            return "サムネイル作成中";
        case "FAILED":
            return "処理失敗";
        case "COMPLETED":
            return "処理完了";
        case "":
            return "準備中";
        default:
            return "ステータス不明";
   }
}

// ビデオ処理進捗値判定
export function getStatusProgress(status: string){
    switch (status.toUpperCase()){
        case "CREATED":
            return 20;
        case "UPLOADED":
            return 50;
        case "EXTRACTING_AUDIO":
            return 60;
        case "CREATING_CAPTIONS":
            return 70;
        case "CREATING_THUMBNAILS":
            return 80;
        case "FAILED":
        case "COMPLETED":
            return 100;
        default:
            return 0;
   }
}

// CaptionをVTTファイルに変換する
export function ConvertCaptionToVtt(fileName: string, captions: VideoCaption[], language?: "ja") {
    let content = "WEBVTT\n\n";
    captions.map((caption) => {
        content += ConvertMsToTimeWithDotMs(caption.startMillis)
                + " --> "
                + ConvertMsToTimeWithDotMs(caption.endMillis)
                + "\n"
                + caption.transcript
                + "\n\n";
        return null;
   });
    return window.URL.createObjectURL(new File([content], fileName + "." + language + ".vtt", {type: "text/vtt"}));
}

// ミリ秒 ⇒ hh:mi:ss.zzz
export function ConvertMsToTimeWithDotMs(millis: number){
    return stringifyVideoTimeWithColons(millis) + "." + ("000" + millis).slice(-3);
}
